package org.hs_soft.runmynesto.domain.model.home.options.operation.option_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashRegisterGlobal(
    @SerialName("e2nIntegrationActive")
    val e2nIntegrationActive: Boolean?,
    @SerialName("e2nReportingActive")
    val e2nReportingActive: Boolean?,
    @SerialName("isRevolutPaymentActive")
    val isRevolutPaymentActive: Boolean?,
    @SerialName("portosIntegrationKey")
    val portosIntegrationKey: String?,
    @SerialName("revolutPaymentDiscount")
    val revolutPaymentDiscount: Double?,
    @SerialName("__typename")
    val typename: String?
)